<template><tile-question-layout v-if="panel_required" :options_loaded="options_loaded" :passed_filter="passed_filter" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :fabricator="fabricator" :has_popup_info="has_popup_info" :popup_info_title_html="popup_info_title_html" :popup_info_inner_html="popup_info_inner_html">

</tile-question-layout></template>

<script type="text/ecmascript-6">
    import DesignerQuestionHardwareHandleInternal from "../DesignerQuestionHardwareHandleInternal.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareHandleInternal
        ],
        props: {
            title: {
                default() {
                    return 'Select Your Internal Door Handle';
                }
            }
        },
        computed: {
            panel_required(){
                return Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 0;
            }
        }
    }
</script>
